import { IconContent } from '@icons';

export const chevronUp: IconContent = {
    sm: '<path d="m8 5.043 4.854 4.853-.707.707L8 6.458l-4.146 4.147-.708-.708L8 5.043Z" />',
    md: '<path d="m12 8.293.354.353 6 6-.708.707L12 9.707l-5.646 5.646-.708-.707 6-6L12 8.293Z" />',
};
